var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form flex col-2" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.innerCode || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.innerDevcBrandName || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.innerDevcBrandCode || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.name))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.model))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.fixedSpec))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.theUnit))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group top" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.imgFile != null
            ? _c("div", { staticClass: "file-area clearfix" }, [
                _vm.imgFile.fileBrowseUrl != null &&
                _vm.imgFile.fileBrowseUrl != ""
                  ? _c(
                      "span",
                      [
                        _c("swb-file-item", {
                          attrs: {
                            fileUuid: _vm.imgFile.fileUuid,
                            fileBrowseUrl: _vm.imgFile.fileBrowseUrl,
                            deletable: false
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.title))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.innerDevcCatName || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.innerDevcCode || ""))])
        ])
      ]),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(13),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [
            _vm._v(_vm._s(_vm.devcUseMannerMap[_vm.devcDef.useManner]))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(14),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.assetTypeMap[_vm.devcDef.assetType]))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(15),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.splitible ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(16),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c(
            "span",
            { class: _vm.devcDef.normalized ? "font-green" : "font-red" },
            [_vm._v(_vm._s(_vm.devcDef.normalized ? "在账资产" : "账外设备"))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.devcDef.normalized
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(17),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [
                _vm._v(_vm._s(_vm.assetNatureMap[_vm.devcDef.assetNature]))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.devcDef.normalized
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(18),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.assetKindName || ""))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(19),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.devcGroupFullName || ""))])
        ])
      ]),
      _vm._v(" "),
      _vm._m(20),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(21),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.tempOnly ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(22),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.purchFlag ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _vm.devcDef.purchFlag
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(23),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [
                _vm._v(_vm._s(_vm.devcDef.centBuyRequired ? "是" : "否"))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.devcDef.assetType == 0
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(24),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.setupFlag ? "是" : "否"))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.devcDef.assetType == 0
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(25),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [
                _vm._v(_vm._s(_vm.devcDef.vendorUknoFlag ? "是" : "否"))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(26),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.stockFifo ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _vm._m(27),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(28),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _vm.devcDef.deprSpecId != null && _vm.devcDef.deprSpecId != -1
            ? _c("span", [
                _c(
                  "a",
                  {
                    staticClass: "table-cell-link",
                    on: {
                      click: function($event) {
                        _vm.showDeprSpec(_vm.devcDef.deprSpecId)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.devcDef.deprSpecName))]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(29),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _vm.devcDef.deprSpecId != null && _vm.devcDef.deprSpecId != -1
            ? _c("span", [
                _c(
                  "a",
                  {
                    staticClass: "table-cell-link",
                    on: {
                      click: function($event) {
                        _vm.showDeprSpec(_vm.devcDef.deprSpecId)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.devcDef.deprSpecCode))]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.devcDef.normalized
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(30),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.durableLife || ""))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(31),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(32),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [
            _vm._v(_vm._s(_vm.migratedFlagMap[_vm.devcDef.migratedFlag]))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.devcDef.assetType == 0
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(33),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.asmblFlag ? "是" : "否"))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.devcDef.assetType == 0 && _vm.devcDef.asmblFlag
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(34),
            _vm._v(" "),
            _c("div", { staticClass: "form-value " }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.asmbAccCount))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(35),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.version))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(36),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.historic ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(37),
        _vm._v(" "),
        _c("div", { staticClass: "form-value " }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.baseInnerCode))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(38),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.devcDef.applyState == 0
            ? _c("span", { staticClass: "font-gray1" }, [_vm._v("未申请")])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.applyState == 1
            ? _c("span", { staticClass: "font-gold" }, [_vm._v("已申请")])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.applyState == 2 && _vm.devcDef.auditState == 1
            ? _c("span", { staticClass: "font-green" }, [_vm._v("审核已通过")])
            : _vm._e(),
          _vm._v(" "),
          _vm.devcDef.applyState == 2 && _vm.devcDef.auditState == -1
            ? _c("span", { staticClass: "font-red" }, [_vm._v("审核未通过")])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(39),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.devcDef.fiscalAuditNeeded ? "是" : "否"))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.devcDef.fiscalAuditNeeded
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(40),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.devcDef.fiscalAuditState == 1
                ? _c("span", { staticClass: "font-green" }, [
                    _vm._v("审核已通过")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.devcDef.fiscalAuditState == -1
                ? _c("span", { staticClass: "font-red" }, [
                    _vm._v("审核未通过")
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.devcDef.fiscalAuditNeeded
        ? _c("div", { staticClass: "form-group" }, [
            _vm._m(41),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.fiscalAuditorName))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(42),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.inStkQuantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(43),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.inStkAvQuantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(44),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.inUseQuantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(45),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.quantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(46),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.devcDef.disabled ? "已禁用" : "未禁用"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(47),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.disableCause))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(48),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.disableTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(49),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.disablerName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(50),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.creatorName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(51),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.createTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(52),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.devcDef.memo))])
        ])
      ]),
      _vm._v(" "),
      _vm._m(53),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.devcFiles, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { align: "left", prop: "fileName", label: "手册名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              width: "100",
              prop: "innerOnly",
              label: "使用范围"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.innerOnly
                      ? _c("span", [_vm._v("内部使用")])
                      : _c("span", [_vm._v("通用")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", width: "100", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.viewManual(scope.row)
                          }
                        }
                      },
                      [_vm._v("预览")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.downloadManual(scope.row)
                          }
                        }
                      },
                      [_vm._v("下载")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("定义编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产品牌")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产品牌编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("型号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单位")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产描述全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产分类编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("管理信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产管理方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("按金额管理")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("定义完善程度")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产属性")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务类别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维保分组")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("采购信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("仅用于临采")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("用于采购")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("必须集中采购")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要安装")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要供应商提供唯一标识码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("先进先出")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("折旧与分摊规则")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规则名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规则编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用年限(月)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附加信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("转移标记")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("含组装商品")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("组装件数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("版本")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("历史版本")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("基础定义编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否需要财务审核")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务审核状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务审核人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在库数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在库可用数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在用数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已禁用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用操作人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资料手册")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a047d48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a047d48","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcDef/MerchtDevcDefDetail.vue
// module id = 2399
// module chunks = 0